// extracted by mini-css-extract-plugin
export var notificationHost = "_lp-0";